module.exports = __webpack_public_path__ + "img/sample-1.e738f76.webp";